<template>
    <div
        class="time-input"
        :class="{ 'validate-error': !validateResult, readonly: readonly, invisible: invisible }"
        @dblclick="dblclickHandle"
        @mousedown.stop
        @click="clickHandle"
        @select="focus"
    >
        <div v-if="readonly || invisible" class="readonly-text">{{ value }}</div>
        <template v-else>
            <input
                :style="style"
                :name="options.field"
                v-model="value"
                :readonly="inputEditable"
                ref="input"
                autocomplete="off"
            />
            <div class="time-input-icon" v-on:click.stop="focus">
                <clock color="#777" />
            </div>
        </template>
        <div class="validate-error-icon" v-if="validateResult === false" :class="{ input: !readonly }" @click.stop>
            <info-image @mouseenter.stop="errorIconMouseenter" @mouseleave.stop="errorIconMouseleave"></info-image>
        </div>
    </div>
</template>
<script>
import jQuery from 'jquery';
import Vue from 'vue';
import GikamCore from 'gikam';
import timePicker from './timePicker';
import infoImage from '../../img/info.vue';
import BaseField from '../../baseField/baseField.vue';
const defaultOptions = {
    //时间是否循环展示
    circular: true,
    style: {
        backgroundColor: '#fff'
    }
};

const Gikam = GikamCore.getTopGikam();

export default {
    name: 'timeField',

    props: {
        options: Object,
        propValue: String,
        rowIndex: Number,
        cellIndex: Number,
        propInvisible: {
            type: Boolean,
            default: false
        }
    },
    components: { infoImage },
    extends: BaseField,
    data() {
        return {
            style: this.options.style || defaultOptions.style,
            validateResult: true,
            readonly: Gikam.isNotEmpty(this.propReadonly) ? this.propReadonly : this.options.readonly,
            field: this.options.field,
            value: this.propValue,
            invisible: this.propInvisible,
            circular: this.options.circular || defaultOptions.circular
        };
    },

    computed: {
        time() {
            let tempDate = Gikam.DateUtils.formatter(new Date(), 'yyyy-MM-dd');
            if (this.value) {
                return Gikam.DateUtils.toDateTime(tempDate + ' ' + this.value.trim());
            } else if (this.options.defaultValue) {
                return Gikam.DateUtils.toDateTime(tempDate + ' ' + this.options.defaultValue.trim());
            } else {
                return '';
            }
        },

        inputEditable() {
            return this.options.editable === true ? false : 'readonly';
        }
    },

    watch: {
        value(val, oldVal) {
            if (this.form || this.grid) {
                this.validateResult = this.validate();
            } else {
                this.validateResult = true;
            }
            if (Gikam.isTrue(this.validateResult)) {
                this.$emit('change', this.options.field, val, this.rowIndex, oldVal);
            }
        },

        propValue(val) {
            this.value = val;
        }
    },

    methods: {
        cleanTimePicker() {
            Gikam.timePicker.destroy();
        },

        popTimePicker() {
            let _this = this;
            if (Gikam.timePicker) {
                this.cleanTimePicker();
            }

            if (!Gikam.isTrue(this.propInvisible)) {
                Gikam.simulatedEvent(document, 'mousedown');
            }

            if (this.readonly) {
                return;
            }

            Gikam.timePicker = new Vue({
                el: Gikam.createDom('div', window.top.document.body),
                components: { timePicker },
                methods: {
                    destroy() {
                        jQuery(this.$el).remove();
                        this.$destroy();
                        Gikam.timePicker = null;
                    }
                },
                render() {
                    return <time-picker timeInput={_this} />;
                }
            });
        },

        dblclickHandle() {
            this.$emit('dblclick', this);
        },

        override(props) {
            Gikam.extend(defaultOptions, props);
        },

        dumpActiveCell() {
            Gikam.timePicker && this.cleanTimePicker();
            this.$refs.input && this.$refs.input.blur();
        },

        activeCell() {
            if (this.invisible) {
                this.$emit('click', this);
            } else {
                this.focus();
            }
        },

        focus(noPop) {
            this.$refs.input && this.$refs.input.focus();
            this.$emit('saveCoordinate');
            if (noPop !== true) {
                this.popTimePicker();
            }
        },

        //点击时保存当前单元格的坐标
        clickHandle() {
            if (!this.invisible) {
                this.$emit('saveCoordinate');
            } else {
                this.$emit('click', this);
            }
        }
    }
};
</script>

<style scoped>
.time-input {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: stretch;
    color: #666;
    font-size: 12px;
}

.filter .time-input {
    height: 24px;
}

.time-input.readonly {
    display: flex;
    align-items: center;
}

.time-input input,
.time-input .readonly-text {
    width: 100%;
    height: 100%;
    border-radius: 4px;
    border: 1px solid #d9d9d9;
    padding-right: 30px;
    padding-left: 8px;
    color: rgba(0, 0, 0, 0.65);
    font-size: 12px;
}

.time-input .readonly-text {
    background-color: #f4f4f4;
    display: flex;
    align-items: center;
}

.time-input input:focus {
    border: 1px solid rgba(0, 122, 255, 0.5);
}

.time-input .time-input-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    cursor: pointer;
    margin-left: -30px;
}

.time-input .time-input-icon svg {
    width: 16px;
    height: 16px;
}

.invisible .readonly-text {
    background-color: transparent;
    border: none;
}

.time-input .validate-error-icon {
    margin-left: -25px;
    display: flex;
    align-items: center;
}

.time-input.validate-error input {
    padding-right: 53px;
}

.time-input .validate-error-icon.input {
    margin-left: -48px;
}

.time-input .validate-error-icon svg {
    height: 20px;
    cursor: pointer;
}

.time-input.validate-error .readonly-text,
.time-input.validate-error input {
    border-color: #ff6e6e;
}
</style>
